"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./tour-facilitator-user");
class TourDto {
}
exports.TourDto = TourDto;
